// src/pages/forecast/floodforecast/FloodforecastMap/WaterLevelStatusColor.js
import L from 'leaflet';

const WL_COLORS = {
  gray:   '#9E9E9E', // ต่ำกว่าท้องน้ำ
  green:  '#00AA00', // ปกติ
  yellow: '#FFFF00', // เฝ้าระวัง
  orange: '#FF8000', // เตือนภัย
  red:    '#FF0000', // วิกฤต (เกินตลิ่ง)
};

/**
 * @param {number} value  - ค่าระดับน้ำหรือปริมาณน้ำท่าล่าสุด
 * @param {Array}  teleStation - ข้อมูลสถานี (array index เดียวกับใน chart)
 * @param {string} type   - 'wl' | 'discharge'
 */
export default function WaterLevelStatusColor(value, teleStation, type = 'wl') {
    if (!teleStation || value === null || value === undefined || isNaN(value)) {
        return { color: WL_COLORS.gray, icon: makeIcon(WL_COLORS.gray) };
    }

  let color = WL_COLORS.gray;

  if (type === 'wl') {
    const bottom  = parseFloat(teleStation[7]);  // ท้องน้ำ
    const low     = parseFloat(teleStation[8]);  // ล่าง
    const mid     = parseFloat(teleStation[9]);  // กลาง
    const bank    = parseFloat(teleStation[10]); // ตลิ่ง

    if (value < bottom)       color = WL_COLORS.gray;
    else if (value < low)     color = WL_COLORS.green;
    else if (value < mid)     color = WL_COLORS.yellow;
    else if (value < bank)    color = WL_COLORS.orange;
    else                      color = WL_COLORS.red;
  }

  if (type === 'discharge') {
    const low  = parseFloat(teleStation[8]);
    const mid  = parseFloat(teleStation[9]);
    const bank = parseFloat(teleStation[10]);

    if (value < low)       color = WL_COLORS.green;
    else if (value < mid)  color = WL_COLORS.yellow;
    else if (value < bank) color = WL_COLORS.orange;
    else                   color = WL_COLORS.red;
  }

  return { color, icon: makeIcon(color) };
}

function makeIcon(color) {
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
      <circle cx="14" cy="14" r="10" fill="${color}" stroke="#fff" stroke-width="2"/>
    </svg>`;

  return L.divIcon({
    html: svg,
    className: '',
    iconSize: [28, 28],
    iconAnchor: [14, 14],
  });
}